module.exports = __webpack_public_path__ + "static/2-82cee7d117feb0b21741281b062327d7.svg";